/* eslint-disable @typescript-eslint/no-explicit-any */
import { APPLICATION_BREAKPOINTS } from '@marriott/mi-ui-library';
import { useState, useEffect } from 'react';
import { useWindowSize } from './useWindowSize';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const eventUtil = {
  on(event: any, callback: (data: any) => void) {
    document.addEventListener(event, e => callback(e.detail));
  },
  dispatch(event: any, data: any) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event: any, callback: () => void) {
    document.removeEventListener(event, callback);
  },
};

/**
 * Hook to return whethre current window size is greater than viewport size provided. Current sizes from
 * global styles are:
 * {
 *   "viewportXS": "0px",
 *   "viewportS": "576px",
 *   "viewportM": "768px",
 *   "viewportL": "992px",
 *   "viewportXl": "1200px"
 * }
 * @param viewportSize
 * @returns boolean
 */
export function useCheckBreakpoint(viewportSize: string | number) {
  const [isGreater, setIsGreater] = useState(false);
  const { width } = useWindowSize();

  const targetViewportSize = APPLICATION_BREAKPOINTS[viewportSize] || 0;

  useEffect(() => {
    if (width && width >= targetViewportSize) {
      setIsGreater(true);
    } else {
      setIsGreater(false);
    }
  }, [width, targetViewportSize]);

  return isGreater;
}
